import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "menu-page" }
const _hoisted_2 = {
  class: "menu-page__status-grid",
  "aria-label": "업무 현황"
}
const _hoisted_3 = { class: "menu-page__body" }
const _hoisted_4 = { class: "menu-section__header" }
const _hoisted_5 = { class: "menu-section__mark" }
const _hoisted_6 = { class: "menu-section__grid" }

import NavButton from '@/components/NavButton.vue';
import { computed } from 'vue';

type MenuItem = {
  title: string;
  description: string;
  icon: string;
  color: string;
  link: string;
};

type MenuSection = {
  title: string;
  description: string;
  mark: string;
  items: MenuItem[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuPage',
  setup(__props) {

const menuSections: MenuSection[] = [
  {
    title: '필수 업무',
    description: '사용자, 환자, 접수, 차트, 청구와 문서 발급',
    mark: '01',
    items: [
      { title: '사용자/권한<br>관리', description: '초대, 목록, 권한 변경', icon: 'USER', color: '#FFF', link: '/users-permissions' },
      { title: '환자 등록<br>기본정보', description: '차트번호, 연락처, 병력', icon: 'PAT', color: '#FFF', link: '/patients' },
      { title: '접수 및<br>내원 관리', description: '대기, 상태, 내원 이력', icon: 'DESK', color: '#FFF', link: '/reception' },
      { title: '전자차트<br>EMR', description: '진료기록, 오더, 이미지', icon: 'EMR', color: '#FFF', link: '/emr' },
      { title: '보험청구<br>관리', description: '청구자료와 오류 확인', icon: 'INS', color: '#FFF', link: '/insurance-claims' },
      { title: '문서 및<br>증명서 발급', description: '영수증, 처방전, 기록부', icon: 'DOC', color: '#FFF', link: '/documents' },
    ],
  },
  {
    title: '진료 운영',
    description: '예약, 상담, 수납, CRM과 오더 관리',
    mark: '02',
    items: [
      { title: '예약 관리<br>캘린더', description: '의료진별 예약 현황', icon: 'CAL', color: '#FFF', link: '/calendar' },
      { title: '예약 입력<br>변경 이력', description: '예약 등록과 상태 변경', icon: 'RSV', color: '#FFF', link: '/reservation' },
      { title: '치료계획<br>상담', description: '상담 자료와 계획 흐름', icon: 'PLAN', color: '#FFF', link: '/plan' },
      { title: '가격 책정<br>치료비 계획', description: '치료 항목별 비용 산정', icon: 'COST', color: '#FFF', link: '/price' },
      { title: '수납 및<br>결제 관리', description: '미수, 환불, 분할수납', icon: 'PAY', color: '#FFF', link: '/payments' },
      { title: '환자관리<br>CRM', description: '리콜, 해피콜, 미이행', icon: 'CRM', color: '#FFF', link: '/client-manage' },
      { title: '문진표<br>PI 입력', description: '문진 항목과 제출', icon: 'FORM', color: '#FFF', link: '/questionnaire' },
      { title: '상담 보드<br>사진', description: '사진 기반 상담 보드', icon: 'IMG', color: '#FFF', link: '/monitor' },
      { title: '오더 및<br>스캔 관리', description: '스캔, 배송, 파일 로그', icon: 'ORD', color: '#FFF', link: '/orders' },
    ],
  },
  {
    title: '관리 및 설정',
    description: '통계, 알림, 마스터와 추후 연동 설정',
    mark: '03',
    items: [
      { title: '통계 및<br>경영관리', description: '매출, 내원, 직원 실적', icon: 'STAT', color: '#FFF', link: '/analytics' },
      { title: '알림 및<br>리콜 기능', description: '알림 규칙과 리콜 관리', icon: 'ALRT', color: '#FFF', link: '/alerts' },
      { title: '코드마스터<br>진료항목', description: '수가, 상병, 행위 코드', icon: 'CODE', color: '#FFF', link: '/codes' },
      { title: '감사 로그<br>이력 조회', description: '사용자 작업 기록', icon: 'LOG', color: '#FFF', link: '/audit' },
    ],
  },
];

const statusCards = computed(() => [
  { label: '전체 메뉴', value: `${allMenuItems.value.length}개` },
  { label: '필수 업무', value: `${menuSections[0].items.length}개` },
  { label: '진료 운영', value: `${menuSections[1].items.length}개` },
  { label: '관리 설정', value: `${menuSections[2].items.length}개` },
]);

const allMenuItems = computed<MenuItem[]>(() => menuSections.flatMap((section) => section.items));

const activeCount = (items: MenuItem[]) => items.filter((item) => item.link).length;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusCards.value, (status) => {
        return (_openBlock(), _createElementBlock("article", {
          key: status.label
        }, [
          _createElementVNode("span", null, _toDisplayString(status.label), 1),
          _createElementVNode("strong", null, _toDisplayString(status.value), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("main", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuSections, (section) => {
        return _createElementVNode("section", {
          key: section.title,
          class: "menu-section"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(section.mark), 1),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(section.title), 1),
                _createElementVNode("p", null, _toDisplayString(section.description), 1)
              ])
            ]),
            _createElementVNode("span", null, _toDisplayString(activeCount(section.items)) + " / " + _toDisplayString(section.items.length), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
              return (_openBlock(), _createBlock(NavButton, {
                key: item.title,
                title: item.title,
                description: item.description,
                icon: item.icon,
                color: item.color,
                link: item.link
              }, null, 8, ["title", "description", "icon", "color", "link"]))
            }), 128))
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})